import { Navigate } from "react-router-dom";
import { useAuth } from "./useAuth";
import { useRole, type TawaRole } from "./useRole";

interface Props {
  roles: TawaRole[];
  children: React.ReactNode;
}

export function RoleRoute({ roles, children }: Props) {
  const { status } = useAuth();
  const role = useRole();
  // useRole() renvoie null tant que le profil OIDC n'est pas chargé ; sans ce
  // garde, tout utilisateur authentifié est redirigé vers /badger au premier
  // rendu, avant que la session soit résolue.
  if (status === "initializing" || status === "renewing") {
    return <div className="tawa-app loading">Chargement…</div>;
  }
  if (role === null || !roles.includes(role)) {
    return <Navigate to="/badger" replace />;
  }
  return <>{children}</>;
}
